<div class="p-2 md:p-4">
  <div class="flex flex-row gap-4 align-items-center justify-content-between">
    <div class="flex-auto">
      <label class="block mb-2" for="percent">Tax name</label>
      <input
        pInputText
        id="name"
        [(ngModel)]="tax.name"
        class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
      />
    </div>

    <div class="flex-auto">
      <label class="block mb-2" for="percent">Tax Percentage</label>
      <p-inputNumber [(ngModel)]="tax.percentage" inputId="percent" suffix="%" [min]="0" [max]="100"> </p-inputNumber>
    </div>
  </div>
  <button
    pButton
    icon="pi pi-plus"
    label="Save"
    (click)="createOrganizationTax()"
    class="p-button-primary my-4 mr-2"
    [disabled]="!isFormValid()"
  ></button>
</div>
